module.exports = __webpack_public_path__ + "media/images/meta/cyclebar/win8-tile-icon-d2383eb7a4c79b19a4abfd3ef9d1088f.png";